<template>
   <div class="mb-3 flex items-center">
      <label class="w-36 text-sm font-medium text-gray-500"> {{ label }}</label>
      <div class="text-sm font-medium text-primary">
         <div v-if="isCheckbox">
            <input
               v-model="modelValue"
               :type="type"
               class="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary"
            />
         </div>
         <div v-else>
            <input
               v-if="edit"
               v-model="modelValue"
               :type="type"
               class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
            />

            <span v-else>
               {{ modelValue || "Please enter" }}
            </span>
         </div>
      </div>
   </div>
</template>

<script setup lang="ts">
const prop = withDefaults(
   defineProps<{
      label: string;
      type?: string;
      edit?: boolean;
   }>(),
   {
      type: "text",
   },
);

const isCheckbox = computed(() => prop.type === "checkbox");

const modelValue = defineModel();
</script>
